import React, { Component, createRef, CSSProperties, Dispatch } from 'react';
import { EAddActivityType } from '../../models/components/add-activity';
import { connect } from 'react-redux';
import { any, bool, number } from 'prop-types';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import * as Action from '../../store/actions/core';
import CAddAssignment from './header-options/add-activity-assignment-modal/main';
import CAddDocument from './header-options/add-activity-document-modal/main';
import CAddProject from './header-options/add-activity-project-modal/main';
import CAddSurvey from './header-options/add-activity-survey-modal/main';
import CAddElesson from './header-options/add-activity-elesson-modal/main';
import CAddVirtualClass from './header-options/add-activity-virtualClass-modal/main';
import CAddLink from './header-options/add-activity-link-modal/main';
import CAddVideo from './header-options/add-acitivty-video-modal/main';
import { IHeaderOptions } from '../../models/components/header-options';
import * as Actions from '../../store/actions/login';
import * as CourseActions from '../../store/actions/coursePage';
import * as AnnouncementAction from '../../store/actions/announcement';
import * as ProfileAction from '../../store/actions/profile';
import * as NotificationPageAction from '../../store/actions/notification';
import { UserType } from '../../models/pages/login.d';
import { Link, Redirect, Route, Router, Switch, withRouter } from 'react-router-dom';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import { SecureImage } from '../../components/core/secureImage';
import { ActivityType } from '../../models/enums/ActivityType';
import { NotificationTypes } from '../../models/enums/NotificationTypes';
import CAddForum from './header-options/add-activity-forum-modal/main';
import { Notification } from '../../components/notification/main';
import BaseModal from '../../modal/base-modal/main';
import LoginAnnouncementModal from '../../modal/in-modal/login-announcement/main';
import MobileAnnouncementModal from '../../modal/in-modal/mobile-login-announcement/main';
import CAddExam from './header-options/add-activity-exam-modal/main';
import CAddLTI from './header-options/add-activity-lti-modal/main';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import CCourseContentWeeks from '../../components/lesson/course-content-weeks/main';
import defalutProfileImage from '../../static/images/defaultImages/defalutProfileImage.jpg';
import CAddInformationNote from './header-options/add-activity-information-note-modal/main';
import Cookies from 'universal-cookie';
import moment from 'moment';
import CSurveyQuestionsModal from '../../components/lesson/activity-cards/survey/modal';
import { Formik, FormikActions, FormikProps } from 'formik';
import { IResponseData } from '../../models/components/activity-card-survey';
import * as SurveyPageActions from '../../store/actions/survey';
import { responseSurvey } from '../../store/actions/survey';
import { SurveyType } from '../../models/enums/SurveyType';
import { SurveyQuestionType } from '../../models/enums/SurveyQuestionType';
import CSurveyQuestionsGeneralTypeModal from '../../components/lesson/activity-cards/survey/generalTypeModal';
import ChangePassword from '../profile/change-password';
import * as MessageActions from '../../store/actions/messages';
import * as AnnouncementActions from '../../store/actions/announcementPage';
import Activity from '../../components/home-page-sub-content/activity';
import Notifications from '../../components/home-page-sub-content/notifications';
import Messages from '../../components/home-page-sub-content/messages';
import * as MessagePageActions from '../../store/actions/messages';
import ChatPanel from '../messages/chatPanel';
import ActivityNotifications from '../../components/home-page-sub-content/activityNotifications';
import { Modal } from 'react-bootstrap';
import NotFound from '../../components/not-found/not-found';
import Truncate from 'react-truncate';
import Tooltip from '../../components/tooltip/main';
import * as ProfilePageAction from '../../store/actions/profile';
import { validateSurveyResponses } from '../../helpers/surveyHelpers';
import { Button } from '../../components/ui-elements/main';

const _lodash = require('lodash');
const T = Translator.create();
const _logger = Log.create('Header Options');
let _common: Common;
let displayCount = 0;
let mobileDisplayCount = 0;
let displaySurveyCount = 0;
let showReadConfirmationIndex = 0;
let displayAnnouncementCount = 0;

const AUTO_UPDATE_INTERVAL_SECONDS: number = 30;

const CourseLogo = `${process.env.PUBLIC_URL}/images/constructor/course_logo.png`;

export class CHeaderOptions extends React.Component<IHeaderOptions, any> {
    timerForNotificationListUpdate: number = 0;
    public activityModalRef: HTMLDivElement | null = null;
    public state = {
        selectedActivity: ActivityType.Other,
        updateActivityId: '',
        url: '',
        allowedActivities: [
            ActivityType.Assignment,
            ActivityType.Document,
            ActivityType.Forum,
            ActivityType.Video,
            ActivityType.VirtualClass,
            ActivityType.Exam,
            ActivityType.Elesson,
            ActivityType.Survey,
            ActivityType.LinkActivity,
            ActivityType.LTIActivity,
            ActivityType.InformationNote
        ],
        allowedProjectActivities: [
            ActivityType.Assignment,
            ActivityType.Document,
            ActivityType.Forum,
            ActivityType.Video,
            this.props.isGroupProject ? ActivityType.VirtualClass : null
        ],
        isOpenAddActivityModal: false,
        isDocumentModalOpen: false,
        isProjectModalOpen: false,
        isAssignmentModalOpen: false,
        isSurveyModalOpen: false,
        isElessonModalOpen: false,
        isVirtualClassModalOpen: false,
        isLinkModalOpen: false,
        isVideoModalOpen: false,
        isForumModalOpen: false,
        isExamModalOpen: false,
        isAnnouncementContentModalOpen: false,
        isLTIModalOpen: false,
        isInformationNoteModalOpen: false,
        modalHeaderData: '',
        mobileAppAnnouncement: false,
        isMobileAnnouncementOpen: false,
        forceChangePassword: false,
        usersAuthorizedToEdit: [
            UserType.Admin,
            UserType.ProgramAdmin,
            UserType.Teacher
        ],
        activityModalOpen: false,
        notificationModalOpen: false,
        messageRedirect: false,
        messageRedirectUrl: '/',
        isAnnouncementModalOpen: false,
        isMessageModelOpen: false,
        activityNotificationModalOpen: false,
        viewActivityStatus: false,
        activityRedirectUrl: '',
        langStatus: false,
        isNotificationPanelOpen: false, // Bildirim paneli
        isActivitiesPanelOpen: false, // Bildirim paneli

        isLanguagePanel: false, // Dil Paneli
        isLanguagePanelModal: false, // Dil Modalı


        isProfilePanel: false, // Dil Paneli

        isNotificationPanelOpenModal: false, // Bildirim Modalı
        isActivitiesPanelOpenModal: false, // Bildirim Modalı

        tabIndex: 0,
        tabIndex2: 3,
        isShowmessages: true,
        isShowannoucements: true,
        notificationReaded: false,
        imageError: false

    };
    private langpopupRef = createRef<HTMLDivElement>();
    private notificationpopupRef = createRef<HTMLDivElement>();
    private activitypopupRef = createRef<HTMLDivElement>();
    private profilepopupRef = createRef<HTMLDivElement>();
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.selectActivityOnClick = this.selectActivityOnClick.bind(this);
        this.headerMessageData = this.headerMessageData.bind(this);

        this.onClickLogout = this.onClickLogout.bind(this);
        this.onClickGotoProfile = this.onClickGotoProfile.bind(this);

        this.onAnnouncementDataClick = this.onAnnouncementDataClick.bind(this);

        this.closeMessageModal = this.closeMessageModal.bind(this);

        this.triggerAnnouncementModal = this.triggerAnnouncementModal.bind(this);

        this.openNotificationPanel = this.openNotificationPanel.bind(this);
        this.closeNotificationPanel = this.closeNotificationPanel.bind(this);
        this.openActivitiesPanel = this.openActivitiesPanel.bind(this);
        this.closeActivitiesPanel = this.closeActivitiesPanel.bind(this);


        this.openNotificationPanelModal = this.openNotificationPanelModal.bind(this);
        this.closeNotificationPanelModal = this.closeNotificationPanelModal.bind(this);
        this.openActivitiesPanelModal = this.openActivitiesPanelModal.bind(this);
        this.closeActivitiesPanelModal = this.closeActivitiesPanelModal.bind(this);
        this.openLanguagePanel = this.openLanguagePanel.bind(this);
        this.closeLanguagePanel = this.closeLanguagePanel.bind(this);
        this.openProfilePanel = this.openProfilePanel.bind(this);
        this.closeProfilePanel = this.closeProfilePanel.bind(this);
        this.openLanguagePanelModal = this.openLanguagePanelModal.bind(this);
        this.closeLanguagePanelModal = this.closeLanguagePanelModal.bind(this);


        this.handleClickOutside = this.handleClickOutside.bind(this);
        showReadConfirmationIndex = 0;
    }

    openProfilePanel() {
        this.setState({ isProfilePanel: true });
    }
    closeProfilePanel() {
        this.setState({ isProfilePanel: false });
    }
    openLanguagePanelModal() {
        this.setState({ isLanguagePanelModal: true });
    }
    closeLanguagePanelModal() {
        this.setState({ isLanguagePanelModal: false });
    }
    openLanguagePanel() {
        this.setState({ isLanguagePanel: true });
    }
    closeLanguagePanel() {
        this.setState({ isLanguagePanel: false });
    }
    openNotificationPanelModal() {
        this.getChatMessages();
        this.setState({ isNotificationPanelOpenModal: true });
    }
    closeNotificationPanelModal() {
        this.setState({ isNotificationPanelOpenModal: false });
    }
    openActivitiesPanelModal() {
        this.getChatMessages();
        this.setState({ isActivitiesPanelOpenModal: true });
    }
    closeActivitiesPanelModal() {
        this.setState({ isActivitiesPanelOpenModal: false });
    }


    openNotificationPanel() {
        this.getChatMessages();
        this.setState({ isNotificationPanelOpen: true });
    }
    closeNotificationPanel() {
        this.setState({ isNotificationPanelOpen: false });
    }
    openActivitiesPanel() {
        //  this.getChatMessages();
        this.setState({ isActivitiesPanelOpen: true });
    }
    closeActivitiesPanel() {
        this.setState({ isActivitiesPanelOpen: false });
    }
    showAnnouncementTabs = () => {
        this.setState((prevState: any) => ({
            tabIndex: 1
        }));
    };
    showMesaggesTab = () => {
        this.setState((prevState: any) => ({
            tabIndex: 0
        }));
    };

    showActivitiesTab = () => {
        this.setState((prevState: any) => ({
            tabIndex2: 2
        }));
    };

    showNotificationsTab = () => {
        this.getNotifications(true);
        this.setState((prevState: any) => ({
            tabIndex2: 3
        }));
    };

    public headerState = (value: string) => {
        if (value) {
            this.setState({ modalHeaderData: value });
        }
    }

    triggerAnnouncementContentModal = () => {
        this.setState({
            ...this.state,
            isAnnouncementContentModalOpen: !this.state.isAnnouncementContentModalOpen,
        });
    };

    triggerSurveyModal = () => {
        this.setState({
            isSurveyModalOpen: !this.state.isSurveyModalOpen,
        });
    }
    returnUserResponsesIndex = (values: any, condition: any) => {
        return values.userResponses.findIndex((r: any) => r.surveyQuestionId === condition) === -1
    }
    checkOpenEndedQuestions = (question: any, values: any) => {
        let isError = false;

        // Soru tipinin açık uçlu olup olmadığını kontrol et
        if (
            question.questionType === SurveyQuestionType.OpenEndedOneLine ||
            question.questionType === SurveyQuestionType.OpenEndedTextArea
        ) {
            const userResponse = values.userResponses.find(
                (r: any) => r.surveyQuestionId === question.surveyQuestionId
            );

            // Kullanıcı yanıtının boş, null veya sadece boşluk olup olmadığını kontrol et
            if (!userResponse || !userResponse.responseOpenEnded || userResponse.responseOpenEnded.trim() === "") {
                isError = true;
            }
        }

        return isError;
    };


    onSubmit = (values: any, formikActions: FormikActions<any>) => {

        const { surveyInfo } = this.props.selectedGeneralSurvey;
        const { userResponses } = values;

        const isError = validateSurveyResponses(surveyInfo, userResponses);

        if (isError) {
            Notification.setNotification('error', T.t('r_survey_unresponded_questions_error'), 'topRight');
        } else {
            const { surveyInfoId, targetList } = this.props.selectedGeneralSurvey!;

            if (surveyInfoId && targetList[0].contextType && targetList[0].contextId) {
                this.setState({ isSubmitting: true });
                this.props.dispatch(
                    responseSurvey(
                        values.userResponses,
                        surveyInfoId,
                        targetList[0].contextType,
                        targetList[0].contextId,
                        '',
                        '',
                        '',
                        SurveyType.General,
                        (value: any) => {
                            if (value) {
                                formikActions.setFieldValue('isResponded', true);
                                this.triggerSurveyModal();
                                this.props.dispatch(SurveyPageActions.getSurveysAction('4', 'getHomeBoxSurvey', 'get', 15, 0, undefined, undefined, true));
                                this.setState(this.state);
                                displaySurveyCount = 0;
                                Notification.setNotification('success', T.t('r_survey_sent_successfully'), 'topRight');
                            }
                        },
                        surveyInfo!.questionList.length
                    )
                );
            }
        }
    };



    triggerMobileAnnouncementContentModal = (dontShowAgain: boolean) => {
        this.setState({
            ...this.state,
            isMobileAnnouncementOpen: !this.state.isMobileAnnouncementOpen,
        });

        if (dontShowAgain === true) {
            const cookie = new Cookies();
            cookie.set('MobileAppAnnouncement', 'read', { path: '/', expires: moment().add(30, 'days').toDate() });
            this.setState({
                ...this.state,
                isMobileAnnouncementOpen: false,
            });
        }
    };

    public onAnnouncementClick(announcementId: string) {
        const announcementIndex = this.props.announcements.findIndex(item => item.announcementId === announcementId);
        this.props.dispatch(AnnouncementAction.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncement', 'get', announcementIndex));
        this.triggerAnnouncementContentModal();
        this.setState({ isAnnouncementContentModalOpen: true })
    }

    public onClickChangeAnnouncement = () => {
        const announcementsToShowReadConfirmation = this.props.announcements.filter(item => item.showReadConfirmation && item.unreadCount && item.unreadCount > 0 && !item.isRead);
        const announcements = this.props.announcements.filter(item => item.showOnStartup && !item.isRead && !item.showReadConfirmation);

        if (announcements && announcements.length) {
            const nextItem = this.props.announcements!.find(item => item.announcementId === announcements[0].announcementId);
            if (nextItem) {
                // dispatch next announcement
                const announcementIndex = this.props.announcements.findIndex(item => item.announcementId === nextItem.announcementId);
                this.props.dispatch(AnnouncementAction.GetLoginAnnouncementById(nextItem.announcementId!, 'getLoginAnnouncement', 'get', announcementIndex));
            }
        } else if (announcementsToShowReadConfirmation && announcementsToShowReadConfirmation.length) {
            showReadConfirmationIndex = showReadConfirmationIndex + 1;
            if (showReadConfirmationIndex < announcementsToShowReadConfirmation.length) {
                let nextItemToShowReadConfirmation = announcementsToShowReadConfirmation[showReadConfirmationIndex];
                // dispatch next announcement with confirmation
                const announcementIndex = this.props.announcements.findIndex(item => nextItemToShowReadConfirmation && item.announcementId === nextItemToShowReadConfirmation.announcementId);
                this.props.dispatch(AnnouncementAction.GetLoginAnnouncementById(nextItemToShowReadConfirmation!.announcementId!, 'getLoginAnnouncement', 'get', announcementIndex));
            } else {
                this.triggerAnnouncementContentModal();
            }
        } else {
            this.triggerAnnouncementContentModal();
        }
    }

    public onClickLogout() {
        // TODO: temizle ve yonlendir logine

        this.props.dispatch(ProfilePageAction.setProfileAction(null, "setProfileAction", "set"))
        if (!this.props.isSimulate) {
            if (this.props.isAlmsPlusLoginPage && this.props.userType !== UserType.Admin) {
                this.props.dispatch(Actions.logOff());
                _common.ClearAuthLocalStorage();
                window.location.href = this.props.isAlmsPlusLoginPage ? window.appSettings.DEFAULT_URL : '/';
            } else {
                this.props.dispatch(Actions.AlmsLogOut(() => {
                    this.props.dispatch(Actions.logOff());
                    _common.ClearAuthLocalStorage();
                    window.location.href = this.props.isAlmsPlusLoginPage ? window.appSettings.DEFAULT_URL : '/';

                }));
            }
        }
        else {
            Notification.setNotification('error', T.t('r_user_exitsimulationfirst'), 'topRight');
        }

    }

    public toAlms = () => {
        const token: any = localStorage.getItem('access_token');
        const url: string = window.appSettings.ALMS_URL + '/Account/SSO_Alms?token=' + token;
        window.open(url, '_blank');
    };

    public onClickGotoProfile() {
        this.props.history.push(window.appSettings.DEFAULT_URL + '/u/profile');
    }

    public refreshActivityCards = async (value: any) => {
        await this.getData(value).then(() => {
            setTimeout(() => {
                this.props.dispatch(CourseActions.SetActivityIdAfterAdd(value.activityId));
            }, 1000);
        });
    };

    getData = async (value: any) => {
        // if (value.isUpdateWeeks) {
        //     this.props.dispatch(CourseActions.getCourseContentMenu(this.props.coursePageClassId, value.termWeekId, false, 'getCourseContentMenu', 'get'));
        // }
        if (this.props.courseContentTermWeeks !== undefined) {
            this.props.dispatch(CourseActions.SetTriggerWeekOnClick('',
                value.termWeekId,
                CourseContentMenuType.weekAndActivityStory,
                '',
                this.props.courseContentTermWeeks,
                false,
                this.props.coursePageClassId!,
                this.props.coursePageActivityId!,
                this.props.sortKey ?? '-',
                this.props.activityFilters,
                [],
                this.props.courseDefaultView,
                this.callbackTriggerWeekOnClick,
                'adding-spinner'
            ));
            this.props.courseContentTermWeeks.forEach(item => {
                if (item.termWeekId !== value.termWeekId) {
                    $('#collapse' + item.itemGuid).removeClass("show")
                }
            })
        }

        const url =
            window.appSettings.DEFAULT_URL +
            '/u/course?classId=' +
            this.props.coursePageClassId +
            '&activityId=' +
            this.props.coursePageActivityId +
            '&type=1&actid=' +
            value.activityId +
            '&weekorunitid=' +
            value.termWeekId;
        this.props.history.push(url);
    }

    callbackTriggerWeekOnClick() { }

    public selectActivityOnClick = (event?: any, activityType?: any) => {
        if (activityType) {
            this.state.updateActivityId = this.props.activityId ? this.props.activityId : '';
        } else {
            this.state.updateActivityId = '';
        }
        switch (activityType ? activityType : event.currentTarget.dataset.activitytype) {
            case ActivityType.Document: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Reading: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Project: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isProjectModalOpen: !this.state.isProjectModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Assignment: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Survey: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isSurveyModalOpen: !this.state.isSurveyModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Elesson: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isElessonModalOpen: !this.state.isElessonModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.VirtualClass: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isVirtualClassModalOpen: !this.state.isVirtualClassModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LinkActivity: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isLinkModalOpen: !this.state.isLinkModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Video: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isVideoModalOpen: !this.state.isVideoModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Forum: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isForumModalOpen: !this.state.isForumModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Exam: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isExamModalOpen: !this.state.isExamModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LTIActivity: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isLTIModalOpen: !this.state.isLTIModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.InformationNote: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isInformationNoteModalOpen: !this.state.isInformationNoteModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            default: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
        }
    };

    public onClose = (activityType: any) => {
        switch (activityType) {
            case ActivityType.Document: {
                this.setState({
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Reading: {
                this.setState({
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Project: {
                this.setState({
                    isProjectModalOpen: !this.state.isProjectModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Assignment: {
                this.setState({
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Survey: {
                this.setState({
                    isSurveyModalOpen: !this.state.isSurveyModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Elesson: {
                this.setState({
                    isElessonModalOpen: !this.state.isElessonModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.VirtualClass: {
                this.setState({
                    isVirtualClassModalOpen: !this.state.isVirtualClassModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LinkActivity: {
                this.setState({
                    isLinkModalOpen: !this.state.isLinkModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Video: {
                this.setState({
                    isVideoModalOpen: !this.state.isVideoModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Forum: {
                this.setState({
                    isForumModalOpen: !this.state.isForumModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Exam: {
                this.setState({
                    isExamModalOpen: !this.state.isExamModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LTIActivity: {
                this.setState({
                    isLTIModalOpen: !this.state.isLTIModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.InformationNote: {
                this.setState({
                    isInformationNoteModalOpen: !this.state.isInformationNoteModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            default: {
                this.setState({
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
        }
    };

    public setCloseModal = (activityType: ActivityType) => {
        const addActivityModal = document.getElementsByClassName('add-activity-modal');
        if (addActivityModal && addActivityModal[0] && addActivityModal[0].classList) {
            addActivityModal[0].classList.remove('slideInRight');
            addActivityModal[0].classList.add('slideOutRight');
        }
        setTimeout(() => {
            this.onClose(activityType);
        }, 300);
    };

    public onCompleteValidateForm = (validations: any, projectActivityValidations?: string[], isProjectSubActivity?: boolean) => {
        let isValidate: boolean = true;

        if (isProjectSubActivity) {
            Object.keys(validations).forEach((validationKey: string) => {
                if (projectActivityValidations!.find(key => key === validationKey)) {
                    Notification.setNotification(
                        'error',
                        T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                        'topRight'
                    );

                    isValidate = false;
                }
            });
        } else {
            Object.keys(validations).forEach((validationKey: string) => {
                Notification.setNotification(
                    'error',
                    T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                    'topRight'
                );

                isValidate = false;
            });
        }

        return isValidate;
    }

    public setModalActivity = (type: ActivityType) => {
        let isSingleClass = false;
        let hasClass = false;
        if (this.props.classes) {
            if (this.props.classes.coursePageActivityId === this.props.coursePageActivityId && this.props.classes.classes.length <= 1) {
                isSingleClass = true;
            }

            if (this.props.classes.classes.length > 0) {
                hasClass = true
            }
        }

        switch (type) {
            case ActivityType.Document:
            case ActivityType.Reading: {
                return (
                    <CAddDocument
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isDocumentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Project: {
                return (
                    <CAddProject
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isProjectModalOpen}
                        setCloseModal={this.setCloseModal}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Assignment: {
                return (
                    <CAddAssignment
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isAssignmentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Survey: {
                return (
                    <CAddSurvey
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isSurveyModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        updateActivityIdFunction={this.updateActivityIdFunction}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Elesson: {
                return (
                    <CAddElesson
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isElessonModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.VirtualClass: {
                return (
                    <CAddVirtualClass
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isVirtualClassModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.LinkActivity: {
                return (
                    <CAddLink
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isLinkModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Video: {
                return (
                    <CAddVideo
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isVideoModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                    />
                );
            }

            case ActivityType.Forum: {
                return (
                    <CAddForum
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isForumModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Exam: {
                return (
                    <CAddExam
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isExamModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        updateActivityIdFunction={this.updateActivityIdFunction}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.LTIActivity: {
                return (
                    <CAddLTI
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isLTIModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.InformationNote: {
                return (
                    <CAddInformationNote
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isInformationNoteModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        hasClass={hasClass}
                    />
                );
            }

            default: {
                return (
                    <CAddAssignment
                        onRefreshActivityCards={this.refreshActivityCards}
                        onClose={this.onClose}
                        isModalOpen={this.state.isAssignmentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
        }
    };

    triggerChangePassword = () => {
        const changePasswordButton = document.getElementById('triggerChangePassword');
        const changePasswordModal = document.getElementById('change-password')
        if (changePasswordModal) {
            const modalClassName = changePasswordModal!.getAttribute('class')
            if (changePasswordButton && !modalClassName!.includes('show') && this.state.forceChangePassword) {
                changePasswordButton.click();
            }
        }
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.setState({
            forceChangePassword: this.props.login.forceChangePassword && this.props.identity.forceChangePassword
        })
        // for homepage box anno
        // this.props.dispatch(AnnouncementPageAction.getAnnouncementsAction('4', 'getHomeBoxAnnouncement', 'get', 20, 0, undefined, undefined, true));
        const cookie = new Cookies().get("MobileAppAnnouncement");

        if (window.location.hostname === "staging.almscloud.com") {
            this.setState({ mobileAppAnnouncement: false })
        }
        else {
            if (cookie) {
                this.setState({ mobileAppAnnouncement: false })
            }
        }
        this.setState({
            url: window.location.pathname
        });
        displayCount = 0;
        mobileDisplayCount = 0;
        showReadConfirmationIndex = 0;
        const messageModuleId = 120; // message modülünün ID'si
        if (!this.props.moduleItems.includes(messageModuleId)) {
            this.setState({ isShowmessages: false });
            this.setState((prevState: any) => ({
                tabIndex: 1
            }));
        }
        const annoucementsModuleId = 150; // annoucements modülünün ID'si
        if (!this.props.moduleItems.includes(annoucementsModuleId)) {
            this.setState({ isShowannoucements: false });
        }
        // this.getNotifications(false);
        // this.timerForNotificationListUpdate = window.setInterval(this.getNotifications.bind(this, false), AUTO_UPDATE_INTERVAL_SECONDS * 1000);
    }

    checkUnreadNotification = () => {
        if ((this.props.notifications)) {
            if (this.props.notifications.length > 0) {
                return true;
            }
        }

        return false;
    }

    checkUnreadActivityNotification = () => {
        if ((this.props.activityNotifications)) {
            if (this.props.activityNotifications.length > 0) {
                return true;
            }
        }

        return false;
    }

    checkUnreadMessage = () => {
        if ((this.props.unreadMessageCount)) {
            if (this.props.unreadMessageCount > 0) {
                return true;
            }
        }

        return false;
    }

    getNotifications = (isOnlyCount: boolean) => {
        this.props.dispatch(NotificationPageAction.GetNotifications(isOnlyCount, 0, 10, 1));
    }

    getActivityNotifications = (isOnlyCount: boolean) => {
        this.props.dispatch(NotificationPageAction.GetActivityNotifications(isOnlyCount, 1, 10, 1));
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.clearInterval(this.timerForNotificationListUpdate);
    }
    handleClickOutside(event: MouseEvent) {
        if (this.langpopupRef.current && !this.langpopupRef.current.contains(event.target as Node)) {
            this.setState({ isLanguagePanel: false });
        }

        if (this.notificationpopupRef.current && !this.notificationpopupRef.current.contains(event.target as Node)) {
            this.setState({ isNotificationPanelOpen: false });
        }

        if (this.activitypopupRef.current && !this.activitypopupRef.current.contains(event.target as Node)) {
            this.setState({ isActivitiesPanelOpen: false });
        }

        if (this.profilepopupRef.current && !this.profilepopupRef.current.contains(event.target as Node)) {
            this.setState({ isProfilePanel: false });
        }
    }
    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.state.forceChangePassword !== prevState.forceChangePassword && this.state.forceChangePassword) {
            this.triggerChangePassword();
        }

        if (this.props.identity.forceChangePassword !== prevProps.identity.forceChangePassword) {
            this.setState({ forceChangePassword: this.props.identity.forceChange && this.props.login.forceChangePassword })
        }

        if (prevProps.announcements !== this.props.announcements && displayCount === 0) {
            const announcements = this.props.announcements.filter(item => item.showOnStartup && !item.isRead).length
                ? this.props.announcements.filter(item => item.showOnStartup && !item.isRead) :
                this.props.announcements.filter(item => item.showReadConfirmation && !item.isRead)

            if (this.state.mobileAppAnnouncement) {
                if (mobileDisplayCount === 0) {
                    mobileDisplayCount++;
                    this.triggerMobileAnnouncementContentModal(false)
                }
            }
            if (announcements && announcements.length > 0) {
                displayCount++;
                this.onAnnouncementClick(announcements[0].announcementId!);
            }
        }

        if (this.props.surveys && prevProps.surveys !== this.props.surveys) {
            const surveysShowOnStartUp = this.props.surveys.filter((item: any) => item.showOnStartUp === 1);

            if (surveysShowOnStartUp && surveysShowOnStartUp.length > 0) {
                if (displaySurveyCount === 0) {
                    displaySurveyCount++;
                    this.props.dispatch(SurveyPageActions.GetGeneralSurveyById(surveysShowOnStartUp[0].surveyId, 'getGeneralSurveyById', 'get'));
                    this.triggerSurveyModal();
                }
            }
        }
    }

    public ConnectToAlms() {
        this.props.dispatch(Actions.connectToAlms('LoadingMain', 'get'));
    }




    public clickToDownload = (message: string, notificationId: string) => {
        const messageSplit = message.split('-FileDownloadLink:');
        let linkUrl: string = window.appSettings.API_URL;

        if (messageSplit.length > 1) {
            const filePath = messageSplit[1];
            if (filePath.startsWith('https:')) {
                linkUrl = filePath;
                _common.DownloadLink(linkUrl, '');
            } else if (filePath.startsWith('zip:')) {
                let zipurl = filePath.replace('zip:', '');
                linkUrl += '/' + zipurl
                _common.DownloadZip(linkUrl, T.t('r_assignment_files'))
            } else {
                if (filePath.startsWith('/')) {
                    linkUrl += filePath;
                } else {
                    linkUrl += '/' + filePath;
                }
                _common.DownloadLink(linkUrl, '');
            }

        }

        this.clickReadNotificationId(notificationId);
    };

    public clickTopNotification = (markAsRead: boolean) => {
        if (markAsRead) {
            this.setState({notificationReaded: true })
            this.props.dispatch(NotificationPageAction.GetReadNotifications( this.readMessageCallback ));
        }
    }

    readMessageCallback=()=>{
        this.setState({ notificationReaded: false })
    }

    public readActivityNotification = (markAsRead: boolean) => {
        if (markAsRead) {
            this.props.dispatch(NotificationPageAction.GetReadActivityNotifications());
        }
    }

    public clickReadNotificationId = (notificationId: string) => {

        this.props.dispatch(NotificationPageAction.GetReadNotificationId(notificationId));
    }

    public readMessages = (markAsRead: boolean) => {
        if (markAsRead) {
            this.props.dispatch(MessageActions.GetReadMessages());
        }
    }

    public readAnnouncement = (markAsRead: boolean) => {
        if (markAsRead) {
            this.props.dispatch(AnnouncementActions.GetReadAnnouncement());
        }
    }

    public getChatMessages = () => {
        this.props.dispatch(
            MessageActions.getHeaderMessageListAction({
                skip: 0,
                take: 0,
                keyword: '',
                spinnerId: 'getContactConversationsAction',
                spinnerType: 'get',
                isGroup: true,
                callback: this.getMessageData
            })
        );

    }


    getMessageData = (value: any) => {
        this.returnHeaderMessage()
    }

    public getAnnouncements = () => {
        this.props.dispatch(AnnouncementActions.getAnnouncementsAction('4', 'selectedAnnouncement', 'get', 20, 0, this.getMessageData));
    }

    public updateActivityIdFunction = (activityId: string) => {
        this.setState({ updateActivityId: activityId });
    }

    public changeLanguage = (lang: string) => {
        let changeCulture = lang;

        if (changeCulture) {
            this.props.dispatch(ProfileAction.getChangeLanguageAction(changeCulture));
        }
    }
    public goFeedbackPage() {
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSdi5YZ6U1u_wCRsfNw6upEn0MII7bryEBuaO3YhNo7yGVDvpw/viewform?entry.2056386244=' + this.props.identity.firstName + '&entry.1209909801=' + this.props.identity.lastName + '&entry.1990079686=' + this.props.login.organizationName + '&entry.251353563=' + this.props.identity.email);
    }

    returnHeaderMessage = () => {
        return (<div className='announcement-dropdown-custom eski-mesaj' tabIndex={0} onMouseDown={this.getChatMessages}>
            <div className="dropdown position-static">
                <div>

                    <div id="notification-dropdown" className="dropdown-menu message-dropdown" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                        <div className='d-flex justify-content-between"'>
                            <div><label className='pl-2'>{T.t('r_menu_messages')}</label></div>  {(this.checkUnreadMessage()) && <div className='ml-auto mark-notifications' onMouseDown={event => this.readMessages(true)}>{T.t('r_notifications_mark_read')}</div>}
                        </div>

                        <div className='row header-message' style={{ margin: "0px" }} >
                            <div className='col-12' >
                                {this.headerMessageData()}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div data-toggle="dropdown" aria-expanded="false" className='tooltip-container' >
                <i className="material-icons d-block animated slideInDown" style={{ opacity: 0.8 }} >
                    chat
                </i>
                {(this.props.unreadMessageCount!) > 0 && <div className='header-count'><span>{this.props.unreadMessageCount}</span></div>}
                <div className="viewType-tooltip">
                    <span className="text-white">{T.t('r_menu_messages')}</span>
                </div>
            </div>

        </div>
        )
    }
    returnHeaderMessage2 = () => {
        return (
            <div className='row header-message p-0' style={{ margin: "0px", overflow: 'hidden' }} >
                <div className='col-12 mobile-h-90' style={{ overflowX: 'hidden', overflowY: 'scroll' }} >
                    {this.headerMessageData()}
                </div>
                {(this.checkUnreadMessage()) && <div className='mx-auto mark-read mb-0 cursor-pointer' onMouseDown={event => this.readMessages(true)}>
                    <Button button_type='secondary' size="small" text={T.t('r_notifications_mark_read')} />
                </div>}

            </div>
        )
    }
    returnHeaderAnnouncement2 = () => {
        return (
            <div className='row header-message' style={{ margin: "0px", overflow: 'hidden' }} >
                <div className='col-12 mobile-h-90' style={{ overflowX: 'hidden', overflowY: 'scroll' }} >
                    {this.headerAnnouncementData()}
                </div>
                {(this.props.unreadAnnounceCount!) > 0 && <div className='mx-auto mark-read mb-0 cursor-pointer' onMouseDown={event => this.readAnnouncement(true)}>
                    <Button button_type='secondary' size="small" text={T.t('r_notifications_mark_read')} />
                </div>}

            </div>
        )
    }


    returnHeaderActivity2 = () => {

        if (this.props.userType === UserType.Student) {
            return (

                <div className='row header-message' style={{ margin: "0px", overflow: 'hidden', position: "relative" }}>
                    <div className='col-12 mobile-h-90' style={{ overflowX: 'hidden', overflowY: 'scroll', paddingBottom: "50px" }}>
                        {this.headerActivityData()}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: ' 1fr 1fr', width: '100%', position: 'absolute', bottom: '0', margin: '0' }}>
                        <div className={`mx-auto mark-read mb-0 cursor-pointer  ${(this.checkUnreadActivityNotification()) ? '' : 'disabled'}`} onMouseDown={event => this.readActivityNotification(true)}>
                            {T.t('r_notifications_mark_read')}
                        </div>
                        <div className="vertical"></div>
                        <div className='mx-auto mark-read mb-0 cursor-pointer' onMouseDown={e => this.onActivityNotificatinClick(true)}>
                            {T.t('r_menu_course_viewAll_notifications')}
                        </div>
                    </div>
                </div>
            )
        }
    }

    returnHeaderNotifications2 = () => {
        return (
            <div className='row header-message' style={{ margin: "0px", overflow: 'hidden' }} >
                <div className='col-12 mobile-h-90' style={{ overflowX: 'hidden', overflowY: 'scroll' }} >
                    {this.props.notifications && this.props.notifications.length > 0 ?
                        (
                            this.headerNotificationData(this.props.notifications)
                        )
                        :
                        (
                            <NotFound message={T.t('r_new_notification_not_found')} />
                        )
                    }
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: ' 1fr 1fr', width: '100%' }}>
                    <div className={`mx-auto mark-read mb-0 cursor-pointer ${(this.checkUnreadNotification()) ? '' : 'disabled'}`} onMouseDown={event => this.clickTopNotification(true)}>
                        <Button button_type='secondary' size="small" text={T.t('r_notifications_mark_read')} />
                    </div>
                    <div className="vertical"></div>
                    <div className='mx-auto mark-read mb-0 cursor-pointer' onMouseDown={e => this.onNotificatinClick(true)} >
                        <Button button_type='secondary' size="small" text={T.t('r_menu_course_viewAll_notifications')} />
                    </div>
                </div>
            </div>
        )
    }

    getMessagerName = (data: any) => {

        let resultName: string;

        if (data.recipientName) {
            if (data.recipientName.length > 20) {
                resultName = data.recipientName.slice(0, 20) + ' ...'
            }
            else {
                resultName = data.recipientName;
            }
        }
        else if (data.name.length > 20) {
            resultName = data.name.slice(0, 20) + ' ...'
        }
        else {
            resultName = data.name;
        }

        return resultName;
    }

    headerMessageData = () => {

        let data = [];

        if (this.props.messages.conversations && this.props.unreadMessageCount! > 0) {

            if (this.props.messages?.conversations!.length > 0) {

                this.props.messages?.conversations!.filter(function (x: any) {
                    return x.myUnreadCount > 0;
                }).map((x: any) => {
                    data.push(
                        <div className={`row hover_gray`} style={{ padding: '1em .5em', cursor: "pointer" }} onMouseDown={evenet => this.onMessageClick(x.originMessageId, x.recipientName || x.name)}>
                            <div className='col-1' style={{ paddingLeft: "5px" }}>
                                {x.images[0] ?
                                    (<SecureImage class="chat_avatar" imageUrl={x.images[0]} />)
                                    :
                                    (<i className="material-icons" style={{ paddingInlineStart: "4px" }}>groups</i>)
                                }</div>
                            <div className={'col-8' + (!_common.isArabic(this.getMessagerName(x), document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>{this.getMessagerName(x)} {x.myUnreadCount > 0 && (<span className='header-message-count'>{x.myUnreadCount}</span>)}</div>
                            <div className='col-3'>{moment(x.lastMessageDate, 'YYYY-MM-DD H:i:s').format('DD.MM.YYYY')}</div>
                        </div>
                    )
                })
            }
            else {
                data.push(<NotFound message={T.t('r_no_new_messages')} />)
            }

        }
        else {
            data.push(<NotFound message={T.t('r_no_new_messages')} />)
        }

        return data;

    }

    public async onMessageClick(messageId: string, senderName: string) {

        await this.props.triggerMessageModal(true).then(() => {
            this.props.dispatch(
                MessagePageActions.getMessageListAction({
                    skip: 0,
                    take: 9,
                    originMessageId: messageId,
                    contextType: 0,
                    contextId: "", // TODO: buraya bir bakmak lazım...
                    imageUrl: "",
                    chatTitleText: senderName,
                    spinnerId: 'getMessageListAction',
                    spinnerType: 'get'
                })
            );
        });
    }

    public async triggerMessageModal() {
        this.setState({
            isMessageModelOpen: true,
        });
    }

    public async closeMessageModal() {
        this.setState({
            isMessageModelOpen: false,
        });
    }

    onClickMessageNavigateUrl = (messageThreadId?: string, tabIndex?: number, isGroup?: boolean, groupClassId?: string) => (event: any) => {
        let url = 'u/Message/Index';

        if (messageThreadId && tabIndex) {
            url = url + '?originMessageId=' + messageThreadId + '&tabIndex=' + tabIndex + '&isGroup=' + isGroup + '&groupClassId=' + groupClassId;
        }
        this.setState({ messageRedirect: true, messageRedirectUrl: url });
    }

    onClickActivityNavigateUrl = (notificationId: string, classId: string, activityId: string, courseId: string, termWeekId: string, activityType: string) => {
        this.setState({
            viewActivityStatus: true,
            activityRedirectUrl: window.appSettings.DEFAULT_URL + '/u/course?classId=' + classId + '&activityId=' + courseId + '&type=1&actid=' + activityId + '&weekorunitid=' + termWeekId,
        });

        this.clickReadNotificationId(notificationId);
    }

    returnHeaderAnnouncement = () => {
        return (<div className='announcement-dropdown-custom eski-duyuru' tabIndex={0}>
            <div className="dropdown position-static">
                <div>
                    <div id="notification-dropdown" className="dropdown-menu message-dropdown" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                        <div className='d-flex justify-content-between"'>

                            <div><label className='pl-2'>{T.t('r_menu_announcements')}</label></div>  {(this.props.unreadAnnounceCount!) > 0 && <div className='ml-auto mark-notifications' onMouseDown={event => this.readAnnouncement(true)}>{T.t('r_notifications_mark_read')}</div>}

                        </div>
                        <div className='row header-message' style={{ margin: "0px" }} >
                            <div className='col-12' >
                                {this.headerAnnouncementData()}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div data-toggle="dropdown" aria-expanded="false" className='tooltip-container' >
                <i className="material-icons d-block animated slideInDown" style={{ opacity: 0.8 }} onMouseDown={this.getAnnouncements}>
                    campaign
                </i>
                {(this.props.unreadAnnounceCount!) > 0 && <div className='header-count'><span>{this.props.unreadAnnounceCount}</span></div>}
                <div className="viewType-tooltip">
                    <span className="text-white">{T.t('r_menu_announcements')}</span>
                </div>
            </div>

        </div>)
    }


    headerAnnouncementData = () => {
        let data = [];
        if (this.props.unreadAnnounceCount! > 0) {
            if (this.props.announcement?.homePageAnnouncements!.length > 0) {
                this.props.announcement?.homePageAnnouncements.filter(function (x) {
                    return !x.isRead;
                }).map((x) => {
                    data.push(<div className={`row ${x.myUnreadCount > 0 && 'header-message-gray'}`} onMouseDown={event => this.onAnnouncementDataClick(x.announcementId, 1)} style={{ paddingBottom: "13px", paddingTop: "13px", borderBottom: "1px solid #c4c4c2", cursor: "pointer" }}>
                        <div className={'col-9 announcement-font-bold' + (!_common.isArabic(x.subject, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>{x.subject}</div>
                        <div className='col-3'>{moment(x.createdDate, 'YYYY-MM-DD H:i:s').format('DD.MM.YYYY')}</div>
                    </div>)
                })

            }
            else {
                data.push(<NotFound message={T.t('r_no_new_announcement')} />)
            }
        }
        else {
            data.push(<NotFound message={T.t('r_no_new_announcement')} />)
        }

        return data;
    }

    public async onAnnouncementDataClick(announcementId: string, index: number) {
        await this.triggerAnnouncementModal().then(() => {
            this.props.dispatch(AnnouncementAction.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncementModal', 'get', index));
        });
    }

    public async triggerAnnouncementModal() {
        let modalOpenStatus = false;
        if (!this.state.isAnnouncementModalOpen) {
            modalOpenStatus = true;
        }

        this.setState({
            isAnnouncementModalOpen: modalOpenStatus
        });

    }

    returnHeaderActivity = () => {

        if (this.props.userType === UserType.Student) {
            return (<div className='announcement-dropdown-custom eski-aktivite' tabIndex={0}>
                <div className="dropdown position-static">
                    <div>

                        <div id="notification-dropdown" className="dropdown-menu message-dropdown" style={{ paddingRight: "0px", paddingLeft: "0px" }}>

                            <div className='d-flex justify-content-between"'>
                                <div><label className='pl-2'>{T.t('r_upcoming_activities')}</label></div>  {(this.checkUnreadActivityNotification()) && <div className='ml-auto mark-notifications' onMouseDown={event => this.readActivityNotification(true)}>{T.t('r_notifications_mark_read')}</div>}
                            </div>

                            <div className='row header-message' style={{ margin: "0px", marginInlineStart: "8px" }} >
                                <div className='col-12' >
                                    {this.headerActivityData()}
                                </div>
                            </div>
                            <div className='row col-12 p-0 m-0 pt-1' onMouseDown={e => this.onActivityNotificatinClick(true)} style={{ justifyContent: "end", cursor: "pointer", paddingInlineEnd: "2px" }}>{T.t('r_menu_course_viewAll_notifications')} <i className="material-icons small" style={{ fontSize: "large", paddingInlineStart: "4px", paddingTop: "4px" }}>visibility</i></div>

                        </div>

                    </div>
                </div>

                <div data-toggle="dropdown" aria-expanded="false" className='tooltip-container' >
                    <i className="material-icons d-block animated slideInDown" style={{ opacity: 0.8 }} onMouseDown={event => this.getActivityNotifications(true)}>
                        event_note
                    </i>
                    {(this.props.activityNotifications.length) > 0 && <div className='header-count'><span>{this.props.activityNotifications.length}</span></div>}
                    <div className="viewType-tooltip">
                        <span className="text-white">{T.t('r_activities')}</span>
                    </div>
                </div>

            </div>
            )
        }
    }

    headerActivityData = () => {

        let data: any = [];

        if (this.props.activityNotifications.length > 0) {
            this.props.activityNotifications.map((x: any, index: any) =>

                data.push(<div className={`row my-2`} style={{ paddingBottom: "13px", paddingTop: "13px", borderLeft: "5px solid", borderLeftColor: _common.ActivityColours[x.activityType].toString().toLowerCase(), backgroundColor: "#fbfaf6" }}>
                    <div className='row p-0 m-0' style={{ cursor: "pointer", height: '100%' }} onMouseDown={e => this.onClickActivityNavigateUrl(x.notificationId, x.classId, x.activityId, x.courseId, x.termWeekId, x.activityType)}>
                        <div className='col-1 text-center' style={{ paddingLeft: "9px" }}>
                            <img
                                src={_common.GetActivityTypeIcons(_common.ActivityValues[x.activityType].toString().toLowerCase())}
                                className="notes-icon"
                            />
                        </div>
                        <div style={{wordBreak:'break-word'}} className="col-11">
                            {x.message.length > 100 ? x.message.slice(0, 100) + "..." : x.message}
                        </div>
                    </div>
                    <div className='row col-12 p-0 m-0'>
                        <div className='col-12 small pt-1' style={{ textAlign: "right", justifyContent: "end", display: "flex" }}>
                            {/* <div className='col-2 text-center p-0'><div className='col-8 text-bg-primary text-wrap p-1 text-center' style={{backgroundColor: '#fbeaf3', color: '#b04a8e', fontWeight: "unset", }}>{T.t(_common.ActivityValues[x.activityType])}</div></div> */}
                        </div>

                        <div className='col-12 small' style={{ textAlign: "right", minHeight: "20px" }}>{moment(x.cretedDate).format('DD.MM.YYYY HH:mm')}</div>
                    </div>
                </div>)
            )

        }
        else {
            data.push(<NotFound message={T.t('r_gen_student_no_newActivity_info')} />)

        }

        return data;

    }

    headerNotificationData = (notifications: any) => {
        let data: any = [];

        if (!this.state.notificationReaded) {
            notifications.forEach((notification: any, index: any) => {
                const isSuccess = notification.notificationType === NotificationTypes.Success;
                const messageParts = notification.message.split(isSuccess ? '-FileDownloadLink:' : '-Message:');
                const message = T.t(messageParts[0], { 0: messageParts[1] });
                const formattedDate = moment(notification.cretedDate).format('DD.MM.YYYY HH:mm');

                const notificationItem = (
                    <div
                        className='cursor-pointer'
                        style={isSuccess ? { fontSize: '14px !important', borderBottom: '2px solid #ccc', marginBottom: '8px', marginTop: '8px' } : {}}
                        key={notification.notificationId}
                        onMouseDown={isSuccess ? this.clickToDownload.bind(this, notification.message, notification.notificationId) : undefined}
                    >
                        <p style={isSuccess ? {} : { position: 'relative', paddingLeft: '30px' }}>
                            {!isSuccess && (
                                <span
                                    className="material-icons"
                                    style={{
                                        fontSize: '14px !important',
                                        position: 'absolute',
                                        left: '0px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#d42424',
                                    }}
                                >
                                    warning
                                </span>
                            )}
                            {message}
                        </p>
                        <p className='text-right small font-weight-bold'>{formattedDate}</p>
                    </div>
                );

                data.push(notificationItem);
            });
        } else {
            data.push(
                <div className='row header-message' style={{ margin: "0px" }}>
                    <div className='col-12 max-height-300'>
                        <NotFound message={T.t('r_new_notification_not_found')} />
                    </div>
                </div>
            );
        }

        return data;
    };
    triggerActivity = () => {
        let activityModalValue = !this.state.activityModalOpen;

        this.setState((prevState: any) => ({ activityModalOpen: activityModalValue }))

    }

    onNotificatinClick = (status: boolean = false) => {
        this.setState({ notificationModalOpen: status });

        this.clickTopNotification(true);
    }

    onActivityNotificatinClick = (status: boolean = false) => {
        this.setState({ activityNotificationModalOpen: status });
        this.readActivityNotification(true);
    }


    openLang = (type: number) => {
        if (type == 1) {
            this.setState({ langStatus: false });
        }
        else {
            this.setState({ langStatus: true });
        }
    }

    returnAnnouncementHeaderModel = () => {
        if (this.props.isSimulate) {
            return;
        }
        return (
            <BaseModal
                minWidth={1100}
                modalIsOpen={this.state.isAnnouncementModalOpen}
                onClose={this.triggerAnnouncementModal.bind(this)}
                headerState={this.state.modalHeaderData}
                headerIcon={'clock'}
                backdrop={this.props.announcement.selectedAnnouncement?.showReadConfirmation && this.props.announcement.selectedAnnouncement.showReadConfirmation != undefined ? 'static' : ''}
                showHeader={true}
            >
                <LoginAnnouncementModal headerState={this.headerState} onClickChangeAnnouncement={this.triggerAnnouncementModal} leftAnnouncementCount={0} />
            </BaseModal>
        )
    }
    returnAnnouncementModel = () => {
        if (this.props.isSimulate) {
            return;
        }
        return (
            <BaseModal
                minWidth={1100}
                modalIsOpen={this.state.isAnnouncementContentModalOpen}
                onClose={this.triggerAnnouncementContentModal}
                headerState={this.state.modalHeaderData}
                backdrop={'static'}
                headerIcon={'clock'}
                showHeader={true}>
                <LoginAnnouncementModal
                    leftAnnouncementCount={
                        this.props.announcements.filter(item => item.showOnStartup && !item.isRead).length
                            ? this.props.announcements.filter(item => item.showOnStartup && !item.isRead).length :
                            this.props.announcements.filter(item => item.unreadCount && item.unreadCount > 0 && !item.isRead && item.showReadConfirmation).length
                    }
                    onClickChangeAnnouncement={this.onClickChangeAnnouncement} headerState={this.headerState} />
            </BaseModal>
        )
    }

    returnSurvey = (initialFormValues: any) => {
        return (
            !this.props.isSimulate && this.state.isSurveyModalOpen && this.props.selectedGeneralSurvey && this.props.selectedGeneralSurvey.surveyInfo && this.props.selectedGeneralSurvey.surveyInfo!.questionList ? (
                <Formik initialValues={initialFormValues} onSubmit={this.onSubmit}>
                    {formik => {
                        return (
                            <CSurveyQuestionsGeneralTypeModal
                                isModalOpen={this.state.isSurveyModalOpen}
                                triggerModal={this.triggerSurveyModal}
                                questionList={this.props.selectedGeneralSurvey.surveyInfo!.questionList}
                                surveyName={this.props.selectedGeneralSurvey.name}
                                surveyId={this.props.selectedGeneralSurvey.surveyInfoId}
                                formik={formik}
                                onSubmit={this.onSubmit}
                                isSubmitting={false}
                                isShowOnStartUp={true}
                            />
                        );
                    }}
                </Formik>
            ) : null
        )
    }

    returnMobileAnnouncementModel = () => {
        return (
            (this.state.isMobileAnnouncementOpen && this.state.isMobileAnnouncementOpen === true) &&
            <div>
                <BaseModal
                    minWidth={850}
                    modalIsOpen={this.state.isMobileAnnouncementOpen}
                    onClose={this.triggerMobileAnnouncementContentModal}
                    headerState={this.state.modalHeaderData}
                    backdrop={'static'}
                    headerIcon={'clock'}>
                    <MobileAnnouncementModal onClickChangeAnnouncement={this.triggerMobileAnnouncementContentModal} />
                </BaseModal>
            </div>
        )
    }

    returnSurveyModal = (initialFormValues: IResponseData) => {
        let retunSurveyHtml = this.returnSurvey(initialFormValues);
        let retuntAnnouncementHtml = this.returnAnnouncementModel();
        let content;

        if (this.state.isAnnouncementContentModalOpen && !this.props.isSimulate) {
            content = retuntAnnouncementHtml;
        } else if (this.state.isSurveyModalOpen) {
            content = retunSurveyHtml;
        } else {
            content = null;
        }
        return content;
    }

    returnCulturName = () => {
        let cultureName = '';
        if (this.props.culture) {
            switch (this.props.culture) {
                case 'en-US':
                    cultureName = 'English';
                    break;
                case 'tr-TR':
                    cultureName = 'Türkçe';
                    break;
                case 'ar-SA':
                    cultureName = 'عربي';
                    break;
                default:
                    cultureName = (T.t('r_choose_language'));
                    break;
            }
        }
        return cultureName;
    }
    returnCulturFlag = () => {
        let flagcode = '';
        if (this.props.culture) {
            switch (this.props.culture) {
                case 'en-US':
                    flagcode = 'english';
                    break;
                case 'tr-TR':
                    flagcode = 'turkish';
                    break;
                case 'ar-SA':
                    flagcode = 'arabic';
                    break;
                default:
                    flagcode = 'turkish';
                    break;
            }
        }
        return flagcode;
    }
    // Kullanıcının adının baş harflerini döndüren metod
    getInitials(): string {
        const { fullName } = this.props;
        if (!fullName) return '';
        const names = fullName.trim().split(' ');
        if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
        return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
      }


    // profil bilgileri dropdown
    userProfileDropdown = () => {
        let cultureName = this.returnCulturName();
        const { profileImagePath, photoKey } = this.props;
        const { imageError } = this.state;
        return (
            !this.props.isProjectActivity && (
                <div className="user-dropdown" id='profileDropDown' tabIndex={0}>
                    <div className="dropdown position-static">
                        <svg
                            className="d-block d-md-none"
                            width="20"
                            height="4"
                            viewBox="0 0 20 4"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="icon/dots" transform="translate(-6.000000, -14.000000)" fill="#000000" fillRule="nonzero">
                                    <path
                                        d="M16,18 C14.8954305,18 14,17.1045695 14,16 C14,14.8954305 14.8954305,14 16,14 C17.1045695,14 18,14.8954305 18,16 C18,17.1045695 17.1045695,18 16,18 Z M16,10 C14.8954305,10 14,9.1045695 14,8 C14,6.8954305 14.8954305,6 16,6 C17.1045695,6 18,6.8954305 18,8 C18,9.1045695 17.1045695,10 16,10 Z M16,26 C14.8954305,26 14,25.1045695 14,24 C14,22.8954305 14.8954305,22 16,22 C17.1045695,22 18,22.8954305 18,24 C18,25.1045695 17.1045695,26 16,26 Z"
                                        id="Shape"
                                        transform="translate(16.000000, 16.000000) rotate(-90.000000) translate(-16.000000, -16.000000) "
                                    />
                                </g>
                            </g>
                        </svg>
                        <button className='profile_btn d-flex flex-row align-items-center position-relative' onClick={this.openProfilePanel} id='profileDropDownImage'>


                                <div>
                                        { !imageError ? (
                                        <img
                                            style={{ width: 45, height: 45, objectFit: 'contain', borderRadius: '50%' }}
                                            src={profileImagePath}
                                            key={photoKey}
                                            alt="Logo"
                                            onError={() => this.setState({ imageError: true })}
                                        />
                                        ) : (
                                        <span className='initials-letter'>{this.getInitials()}</span>
                                        )}
                                    </div>

                            <div className='d-flex flex-column nav-userinfo'>
                                {this.props.fullName &&
                                    _lodash.truncate(this.props.fullName, {
                                        length: 15,
                                        omission: '...'
                                    })
                                }
                                <span className='user-role'>
                                    {this.props.userType === UserType.Student ? T.t('r_gen_student') : ''}
                                    {this.props.userType === UserType.Teacher ? T.t('r_gen_teacher') : ''}
                                    {this.props.userType === UserType.User ? T.t('r_gen_user') : ''}
                                    {this.props.userType === UserType.Parent ? T.t('r_gen_parent') : ''}
                                    {this.props.userType === UserType.Guest ? T.t('r_gen_guest') : ''}
                                </span>
                            </div>
                        </button>
                        <span className="d-block d-md-none">{T.t('r_gen_other')}</span>

                        {this.state.isProfilePanel &&
                            <div ref={this.profilepopupRef} className='profilePanel'>
                                <button onClick={this.onClickGotoProfile} className="dd-profile d-flex align-items-center gap-1" id='viewProfileButton' style={{ background: 'none' }}>

                                    <div>
                                        {!imageError ? (
                                            <img
                                                style={{ maxWidth: '50' }}
                                                src={this.props.profileImagePath}
                                                key={this.props.photoKey ? this.props.photoKey : ''}
                                                className='pull-start'
                                                onError={() => this.setState({ imageError: true })}
                                            />
                                        ) : (
                                            <span className='pull-start' style={{ fontWeight: '500' }}>{this.getInitials()}</span>
                                        )}
                                    </div>
                                    <div>
                                        <Tooltip data={this.props.fullName} position='top'>
                                            <Truncate ellipsis lines={1}>
                                                <span className="dd-name">
                                                    {this.props.fullName && this.props.fullName.length > 20
                                                        ? this.props.fullName.slice(0, 20) + '...'
                                                        : this.props.fullName}
                                                </span>
                                            </Truncate>
                                        </Tooltip>
                                        {/* <span className="dd-name">{this.props.fullName ? this.props.fullName : ''}</span>   */}
                                        <span className="dd-text">{T.t('r_show_profile_button')}</span>
                                    </div>
                                </button>
                                <div className='d-flex  gap-1 mt-4' >
                                    <a
                                        href={_common.storeLinks(this.props.culture, 2)}
                                    >
                                        <img style={{ borderRadius: '0px', width: '100%', height: 'auto' }} src={_common.GetDefaultLogos('apple')} alt='appstoreLogo' />
                                    </a>
                                    <a
                                        href={_common.storeLinks(this.props.culture, 1)}
                                    >
                                        <img style={{ borderRadius: '0px', width: '100%', height: 'auto' }} src={_common.GetDefaultLogos('google')} alt='playstoreLogo' />
                                    </a>
                                </div>
                                {(this.props.userType == UserType.Admin || this.props.userType == UserType.ProgramAdmin) &&
                                    <div className="announcementTabs language_list p-0 mt-3">
                                        <div className={'active '}>
                                            <a onClick={() => this.ConnectToAlms()} href="#" className="text-dark d-flex text-align-center gap-1" id='logoutButton'>
                                                <img src={_common.GetDefaultIcons('logout')} style={{ width: '1.5em', height: '1.5em' }} className="flag-icon mx-1" />
                                                {T.t('r_login_alms')}
                                            </a>
                                        </div>
                                    </div>
                                }

                                <div className="dd-side">
                                    <div className="announcementTabs language_list p-0 ">
                                        <div className={'active '} ><a className='d-flex text-align-center gap-1' target={'_blank'} href={this.props.userType === UserType.Student ? 'https://yardim.advancity.com.tr/egitim365/ogrenci-klavuzu-web' : 'https://yardim.advancity.com.tr/egitim365/egitmen-klavuzu-web'}><img src={_common.GetDefaultIcons('filledask')} style={{ width: '1.5em', height: '1.5em' }} className="flag-icon mx-1" />{T.t('r_guide_help')}</a></div>
                                    </div>
                                </div>

                                <div className="announcementTabs language_list p-0">
                                    <div className={'active '}>
                                        <a onClick={this.onClickLogout} href="#" className="text-dark d-flex text-align-center gap-1" id='logoutButton'>
                                            <img src={_common.GetDefaultIcons('logout')} style={{ width: '1.5em', height: '1.5em' }} className="flag-icon mx-1" />
                                            {T.t('r_logout_close_button')}
                                        </a>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </div>
            )
        )
    }



    public render() {
        let flagcode = this.returnCulturFlag();

        if (this.state.viewActivityStatus) {
            window.location.assign(this.state.activityRedirectUrl);
        }
        let retuntAnnouncementHeaderHtml = this.returnAnnouncementHeaderModel();
        const initialFormValues: IResponseData = {
            userResponses: [],
            isResponded: false,
            questionIndex: 0
        };
        const { history } = this.props;
        history.listen((location: any, action: any) => {
            // location is an object like window.location
            if (action === 'PUSH') {
                this.setState({
                    url: location.pathname.toString()
                });
            }
        });
        // // if edit button clicked from activity card
        if (this.props.activityType) {
            const event: any = null;
            this.selectActivityOnClick(event, this.props.activityType);
            this.props.dispatch(Action.activityTypeSetAction(null, null));
        }

        return (
            <div>
                {
                    (this.state.forceChangePassword && !this.props.isSimulate) &&
                    <ChangePassword forceChange={true} />
                }

                {this.state.isAnnouncementModalOpen ? retuntAnnouncementHeaderHtml : null}

                <ChatPanel onClose={() => this.props.triggerMessageModal(false)} isModalOpen={this.props.isMessageModelOpen} isSubmain={true} id={1} />

                <div className="mx-2 only_mobile_lang">
                    {!this.state.isShowannoucements && !this.state.isShowmessages ?
                        ''
                        : <>
                            <button className='position-relative' style={{ width: '2em' }} onClick={this.openNotificationPanelModal}>
                                <img
                                    src={_common.GetDefaultIcons('headerinbox')}
                                    className="header-icon"
                                />
                                {(this.props.unreadAnnounceCount!) > 0 || (this.props.unreadMessageCount!) > 0 ? <span className="redDot">
                                    {((this.props.unreadAnnounceCount || 0) + (this.props.unreadMessageCount || 0)) > 9
                                        ? '9+'
                                        : (this.props.unreadAnnounceCount || 0) + (this.props.unreadMessageCount || 0)}

                                </span> : ''}
                            </button>
                        </>}
                    <button className='position-relative' style={{ width: '2em' }} onClick={this.openActivitiesPanelModal}>
                        <img
                            src={_common.GetDefaultIcons('headernotification')}
                            className="header-icon"
                        />
                        {(((this.props.activityNotifications.length) > 0 || this.checkUnreadNotification()) && !this.state.notificationReaded) ?
                            <span className="redDot">
                                {((this.props.activityNotifications.length || 0) + (this.props.notifications.length || 0)) > 9
                                    ? '9+'
                                    : (this.props.activityNotifications.length || 0) + (this.props.notifications.length || 0)}

                            </span> : ''}
                    </button>

                    <button className='position-relative' onClick={this.openLanguagePanelModal}>
                        <img
                            src={_common.GetFlagIcons(flagcode.toString())}
                            className="flag-icon"
                            alt={flagcode}
                        />

                    </button>
                    {this.state.isLanguagePanel &&
                        <div ref={this.langpopupRef} className="newNotificationPanel lang_panel">

                            <div className="announcementTabs language_list">
                                <div className={this.props.culture === 'tr-TR' ? 'active' : ''} onMouseDown={event => this.changeLanguage('tr-TR')}><a><img src={_common.GetFlagIcons('turkish')} className="flag-icon mx-1" />Türkçe</a></div>
                                <div className={this.props.culture === 'en-US' ? 'active' : ''} onMouseDown={event => this.changeLanguage('en-US')}><a><img src={_common.GetFlagIcons('english')} className="flag-icon mx-1" />English</a></div>
                                <div className={this.props.culture === 'ar-SA' ? 'active' : ''} onMouseDown={event => this.changeLanguage('ar-SA')}><a><img src={_common.GetFlagIcons('arabic')} className="flag-icon mx-1" />عربي</a></div>

                            </div>
                        </div>
                    }
                </div>

                <div className="header-options-mobile">


                    <a
                        href={_common.storeLinks(this.props.culture, 2)}
                    >
                        <img style={{ borderRadius: '0px', width: '24px', height: '24px' }} src={_common.GetDefaultLogos('appstore')} alt='appstoreLogo' />
                    </a>
                    <a
                        href={_common.storeLinks(this.props.culture, 1)}
                    >
                        <img style={{ borderRadius: '0px', marginLeft: '0.5em', width: '24px', height: '24px' }} src={_common.GetDefaultLogos('playstore')} alt='playstoreLogo' />
                    </a>

                </div>

                <div className="header-options">
                    {(this.state.activityModalOpen) && (
                        <Activity triggerActivity={this.triggerActivity}></Activity>
                    )}

                    {/* yeni mesaj ve duyurular panel tasarımı */}
                    <div className="mx-2">
                        {!this.state.isShowannoucements && !this.state.isShowmessages ?
                            ''
                            :
                            <button className='position-relative' onClick={this.openNotificationPanel}>
                                <img
                                    src={_common.GetDefaultIcons('headerinbox')}
                                    className="header-icon"
                                />
                                {(this.props.unreadAnnounceCount!) > 0 || (this.props.unreadMessageCount!) > 0 ? <span className="redDot">
                                    {((this.props.unreadAnnounceCount || 0) + (this.props.unreadMessageCount || 0)) > 9
                                        ? '9+'
                                        : (this.props.unreadAnnounceCount || 0) + (this.props.unreadMessageCount || 0)}

                                </span> : ''}
                            </button>
                        }
                        {this.state.isNotificationPanelOpen &&
                            <div ref={this.notificationpopupRef} className="newNotificationPanel ">

                                <div className="announcementTabs" style={{ height: '82%' }}>
                                    <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="conversationTabs" role="tablist">
                                        {this.state.isShowmessages ?
                                            <li className="nav-item">
                                                <a className={`nav-link ${this.state.tabIndex === 0 ? 'active show' : ''}`} onClick={this.showMesaggesTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showMesaggesTab(); }}>
                                                    {T.t('r_menu_messages')}{(this.props.unreadMessageCount!) > 0 && <div className='header-count count-position-tab' ><span>{this.props.unreadMessageCount}</span></div>}
                                                </a>
                                            </li>
                                            : ''}
                                        {this.state.isShowannoucements ?
                                            <li className="nav-item">
                                                <a className={`nav-link ${this.state.tabIndex === 1 ? 'active show' : ''}`} onClick={this.showAnnouncementTabs} onKeyPress={(e) => { if (e.key === 'Enter') this.showAnnouncementTabs(); }}>
                                                    {T.t('r_menu_announcements')}{(this.props.unreadAnnounceCount!) > 0 && <div className='header-count count-position-tab' ><span>{this.props.unreadAnnounceCount}</span></div>}
                                                </a>
                                            </li>
                                            : ''}
                                    </ul>

                                    <div className="tab-content" style={{ height: '100%', position: 'relative' }}>
                                        {this.state.isShowmessages ?
                                            <div
                                                className={'tab-pane fade ' + (this.state.tabIndex === 0 ? 'show active' : 'hidden')}
                                                id="home"
                                                role="tabpanel"
                                                aria-labelledby="home-tab"
                                                style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                                            >
                                                {this.returnHeaderMessage2()}
                                            </div>
                                            : ''}
                                        {this.state.isShowannoucements ?
                                            <div
                                                className={`tab-pane fade ${this.state.tabIndex === 1 ? 'show active' : 'hidden'}`}
                                                id="home"
                                                role="tabpanel"
                                                aria-labelledby="home-tab"
                                                style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                                            >
                                                {this.returnHeaderAnnouncement2()}
                                            </div>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>


                    {/* yeni aktiviteler ve bildirimler panel tasarımı */}
                    <div className="mx-2">
                        <button className='position-relative' onClick={this.openActivitiesPanel}>
                            <img
                                src={_common.GetDefaultIcons('headernotification')}
                                className="header-icon"
                            />
                            {((this.props.activityNotifications.length > 0 || this.checkUnreadNotification()) && !this.state.notificationReaded) ? <span className="redDot">
                                {(this.props.activityNotifications.length || 0) + (this.props.notifications.length || 0) > 9
                                    ? '9+'
                                    : (this.props.activityNotifications.length || 0) + (this.props.notifications.length || 0)}

                            </span> : null}

                        </button>
                        {this.state.isActivitiesPanelOpen &&
                            <div ref={this.activitypopupRef} className="newNotificationPanel ">

                                <div className="announcementTabs" style={{ height: '82%' }}>
                                    <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="conversationTabs" role="tablist">
                                        {this.props.userType === UserType.Student ?
                                            <li className="nav-item">
                                                <a className={`nav-link ${this.state.tabIndex2 === 2 ? 'active show' : ''}`} onClick={this.showActivitiesTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showActivitiesTab(); }}>
                                                    {T.t('r_activities')}{(this.props.activityNotifications.length) > 0 && <div className='header-count count-position-tab' ><span>{this.props.activityNotifications.length}</span></div>}
                                                </a>
                                            </li>
                                            : ''}
                                        <li className="nav-item">
                                            <a className={`nav-link ${this.state.tabIndex2 === 3 ? 'active show' : ''}`} onClick={this.showNotificationsTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showNotificationsTab(); }}>
                                                {T.t('r_notifications')}
                                                {(this.checkUnreadNotification() && !this.state.notificationReaded) && <div className='header-count count-position-tab'><span>{this.props.notifications.length}</span></div>}

                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" style={{ height: '100%', position: 'relative' }}>
                                        {this.props.userType === UserType.Student ?
                                            <div
                                                className={`tab-pane fade ${this.state.tabIndex2 === 2 ? 'show active' : 'hidden'}`}
                                                id="home"
                                                role="tabpanel"
                                                aria-labelledby="home-tab"
                                                style={{ height: this.state.tabIndex2 === 0 ? '' : '100%' }}
                                            >
                                                {this.returnHeaderActivity2()}
                                            </div> : ''}
                                        <div
                                            className={`tab-pane fade ${this.state.tabIndex2 === 3 ? 'show active' : 'hidden'}`}
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                            style={{ height: this.state.tabIndex2 === 0 ? '' : '100%' }}
                                        >
                                            {this.returnHeaderNotifications2()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    {/* dil seçimi panel tasarımı */}
                    <div className="mx-2">
                        <button className='position-relative' onClick={this.openLanguagePanel}>
                            <img
                                src={_common.GetFlagIcons(flagcode.toString())}
                                className="flag-icon"
                                alt={flagcode}
                            />

                        </button>
                        {this.state.isLanguagePanel &&
                            <div ref={this.langpopupRef} className="newNotificationPanel lang_panel">

                                <div className="announcementTabs language_list">
                                    <div className={this.props.culture === 'tr-TR' ? 'active' : ''} onMouseDown={event => this.changeLanguage('tr-TR')}><a><img src={_common.GetFlagIcons('turkish')} className="flag-icon mx-1" />Türkçe</a></div>
                                    <div className={this.props.culture === 'en-US' ? 'active' : ''} onClick={event => this.changeLanguage('en-US')}><a><img src={_common.GetFlagIcons('english')} className="flag-icon mx-1" />English</a></div>
                                    <div className={this.props.culture === 'ar-SA' ? 'active' : ''} onClick={event => this.changeLanguage('ar-SA')}><a><img src={_common.GetFlagIcons('arabic')} className="flag-icon mx-1" />عربي</a></div>

                                </div>
                            </div>
                        }
                    </div>
                    {/* Duyuru icon - modal */}
                    <a id="item-0" onMouseDown={this.onClickLogout} className="mobile-logout dd-btn wrap-item mobile-none">
                        <i className="material-icons">exit_to_app</i>
                        {T.t('r_logout_close_button')}
                    </a>
                    {this.state.notificationModalOpen &&
                        <Notifications onNotificatinClick={this.onNotificatinClick} />
                    }
                    {this.state.activityNotificationModalOpen &&
                        <ActivityNotifications onActivityNotificatinClick={this.onActivityNotificatinClick} onClickActivityNavigateUrl={this.onClickActivityNavigateUrl} />
                    }
                    <button hidden id='triggerChangePassword' type="button" data-toggle="modal" data-target="#change-password" data-backdrop="static" data-keyboard="false" />

                    {this.returnMobileAnnouncementModel()}

                    {this.returnSurveyModal(initialFormValues)}
                    {this.userProfileDropdown()}
                </div>

                <Modal show={this.state.isNotificationPanelOpenModal} dialogClassName='m-0 mw-100' fullscreen={true} backdrop='static' animation backdropClassName='secondBackdrop'>
                    <Modal.Body style={{ height: '100vh' }} className='p-0'>
                        <div className="newNotificationPanelModal ">
                            <div className="d-flex justify-content-between px-2 my-2">
                                <span style={{ fontWeight: 500 }}>{T.t('r_menu_announcements')} & {T.t('r_menu_messages')}</span>
                                <a onClick={this.closeNotificationPanelModal}><i style={{ fontSize: '18px' }} className='material-icons-outlined text-dark'>close</i></a>
                            </div>
                            <div className="announcementTabs" style={{ height: '82%' }}>
                                <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="conversationTabs" role="tablist">
                                    {this.state.isShowmessages ?
                                        <li className="nav-item">
                                            <a className={`nav-link ${this.state.tabIndex === 0 ? 'active show' : ''}`} onClick={this.showMesaggesTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showMesaggesTab(); }}>
                                                {T.t('r_menu_messages')}{(this.props.unreadMessageCount!) > 0 && <div className='header-count count-position-tab' ><span>{this.props.unreadMessageCount}</span></div>}
                                            </a>
                                        </li>
                                        : ''}
                                    {this.state.isShowannoucements ?
                                        <li className="nav-item">
                                            <a className={`nav-link ${this.state.tabIndex === 1 ? 'active show' : ''}`} onClick={this.showAnnouncementTabs} onKeyPress={(e) => { if (e.key === 'Enter') this.showAnnouncementTabs(); }}>
                                                {T.t('r_menu_announcements')}{(this.props.unreadAnnounceCount!) > 0 && <div className='header-count count-position-tab' ><span>{this.props.unreadAnnounceCount}</span></div>}
                                            </a>
                                        </li>
                                        : ''}
                                </ul>
                                <div className="tab-content" style={{ height: '100%', position: 'relative' }}>
                                    {this.state.isShowmessages ?
                                        <div
                                            className={`tab-pane fade ${this.state.tabIndex === 0 ? 'show active' : 'hidden'}`}
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                            style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                                        >
                                            {this.returnHeaderMessage2()}
                                        </div>
                                        : ''}
                                    {this.state.isShowannoucements ?
                                        <div
                                            className={`tab-pane fade ${this.state.tabIndex === 1 ? 'show active' : 'hidden'}`}
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                            style={{ height: this.state.tabIndex === 0 ? '' : '100%' }}
                                        >
                                            {this.returnHeaderAnnouncement2()}
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.isActivitiesPanelOpenModal} dialogClassName='m-0 mw-100' fullscreen={true} backdrop='static' animation backdropClassName='secondBackdrop'>
                    <Modal.Body style={{ height: '100vh' }} className='p-0'>
                        <div className="newNotificationPanelModal ">
                            <div className="d-flex justify-content-between px-2 my-2">
                                <span style={{ fontWeight: 500 }}>{T.t('r_activities')} &  {T.t('r_notifications')}</span>
                                <a onClick={this.closeActivitiesPanelModal}><i style={{ fontSize: '18px' }} className='material-icons-outlined text-dark'>close</i></a>
                            </div>
                            <div className="announcementTabs" style={{ height: '82%' }}>
                                <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="conversationTabs" role="tablist">
                                    {this.props.userType === UserType.Student &&
                                        <li className="nav-item">
                                            <a className={`nav-link ${this.state.tabIndex2 === 2 ? 'active show' : ''}`} onClick={this.showActivitiesTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showActivitiesTab(); }}>
                                                {T.t('r_activities')}{(this.props.activityNotifications.length) > 0 && <div className='header-count count-position-tab' ><span>{this.props.activityNotifications.length}</span></div>}
                                            </a>
                                        </li>}
                                    <li className="nav-item">
                                        <a className={`nav-link ${this.state.tabIndex2 === 3 ? 'active show' : ''}`} onClick={this.showNotificationsTab} onKeyPress={(e) => { if (e.key === 'Enter') this.showNotificationsTab(); }}>
                                            {T.t('r_notifications')}
                                            {(this.checkUnreadNotification()) && <div className='header-count count-position-tab'><span>{this.props.notifications.length}</span></div>}

                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content" style={{ height: '100%', position: 'relative' }}>
                                    <div
                                        className={`tab-pane fade ${this.state.tabIndex2 === 2 ? 'show active' : 'hidden'}`}
                                        id="home"
                                        role="tabpanel"
                                        aria-labelledby="home-tab"
                                        style={{ height: this.state.tabIndex2 === 0 ? '' : '100%' }}
                                    >
                                        {this.returnHeaderActivity2()}
                                    </div>
                                    <div
                                        className={`tab-pane fade ${this.state.tabIndex2 === 3 ? 'show active' : 'hidden'}`}
                                        id="home"
                                        role="tabpanel"
                                        aria-labelledby="home-tab"
                                        style={{ height: this.state.tabIndex2 === 0 ? '' : '100%' }}
                                    >
                                        {this.returnHeaderNotifications2()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal show={this.state.isLanguagePanelModal} size='sm' className='top-10' dialogClassName='' backdrop='static' animation backdropClassName='secondBackdrop'>
                    <Modal.Body className='p-0'>
                        <div className="newNotificationPanelModal lang_panel">
                            <div className="d-flex justify-content-between px-2 my-2">
                                <span style={{ fontWeight: 500 }}>{T.t('r_choose_language')}</span>
                                <a onClick={this.closeLanguagePanelModal}><i style={{ fontSize: '18px' }} className='material-icons-outlined text-dark'>close</i></a>
                            </div>
                            <div className="announcementTabs language_list">
                                <div className={this.props.culture === 'tr-TR' ? 'active' : ''} onMouseDown={event => this.changeLanguage('tr-TR')}><a><img src={_common.GetFlagIcons('turkish')} className="flag-icon mx-1" />Türkçe</a></div>
                                <div className={this.props.culture === 'en-US' ? 'active' : ''} onClick={event => this.changeLanguage('en-US')}><a><img src={_common.GetFlagIcons('english')} className="flag-icon mx-1" />English</a></div>
                                <div className={this.props.culture === 'ar-SA' ? 'active' : ''} onClick={event => this.changeLanguage('ar-SA')}><a><img src={_common.GetFlagIcons('arabic')} className="flag-icon mx-1" />عربي</a></div>

                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHeaderOptions): IHeaderOptions => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHeaderOptions = Object.assign({}, ownProps, {
        activityType: state.mainMenuRoot.activityAddType,
        activityId: state.mainMenuRoot.activityAddId,
        userType: state.login.identitiy.userType,
        profileImagePath: state.login.identitiy.profileImagePath,
        photoKey: state.profile.photoKey,
        fullName: state.login.identitiy.fullName,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        announcements: state.announcement.homePageAnnouncements,
        notifications: state.notification.notifications,
        unreadNotificationCount: state.notification.unreadNotificationCount,
        isShowActivityAdd: state.coursePage.isShowActivityAdd,
        culture: state.login.identitiy.culture,
        defaultCulture: state.login.login.defaultCulture,
        classes: state.coursePage.classes,
        identity: state.login.identitiy,
        login: state.login.login,
        surveys: state.survey.homePageSurveys,
        selectedGeneralSurvey: state.survey.selectedGeneralSurvey,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        isSimulate: state.login.identitiy.isSimulate,
        courseDefaultView: state.coursePage.courseDefaultView,
        unreadMessageCount: state.message.unreadMessageCount,
        unreadAnnounceCount: state.announcement.unreadAnnounceCount,
        messages: state.message,
        announcement: state.announcement,
        activityNotifications: state.notification.activityNotifications,
        isAlmsPlusLoginPage: state.login.login.isAlmsPlusLoginPage,
        moduleItems: state.login.login.moduleItems,
        sortKey: state.coursePage.courseSortingKey,
        activityFilters: state.coursePage.activityFilters
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.announcement.homePageAnnouncements === prev.announcement.homePageAnnouncements &&
        next.mainMenuRoot.activityAddType === prev.mainMenuRoot.activityAddType &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.notification.notifications === prev.notification.notifications &&
        next.notification.unreadNotificationCount === prev.notification.unreadNotificationCount &&
        next.coursePage.isShowActivityAdd === prev.coursePage.isShowActivityAdd &&
        next.login.identitiy.culture === prev.login.identitiy.culture &&
        next.coursePage.classes === prev.coursePage.classes &&
        next.login.identitiy === prev.login.identitiy &&
        next.login.login === prev.login.login &&
        next.login.login.forceChangePassword === prev.login.login.forceChangePassword &&
        next.login.identitiy.forceChangePassword === prev.login.identitiy.forceChangePassword &&
        next.survey.homePageSurveys === prev.survey.homePageSurveys &&
        next.survey.selectedGeneralSurvey === prev.survey.selectedGeneralSurvey &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView &&
        next.message.unreadMessageCount === prev.message.unreadMessageCount &&
        next.announcement.unreadAnnounceCount === prev.announcement.unreadAnnounceCount &&
        next.message === prev.message &&
        next.announcement === prev.announcement &&
        next.notification.activityNotifications === prev.notification.activityNotifications;
    return ret;
};


const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const HeaderOptions = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CHeaderOptions);

export default withRouter<any, any>(HeaderOptions);
